import { DietIdEnum, DietModeType } from '@front-activerse/common-components';

export const DIET_TYPES = [
  {
    id: 5,
    value: DietIdEnum.DIET_ID_BUDGET,
    optionTitle: 'app.nutritionSettings.dietType.optionBudget.title',
    optionDescription: 'app.nutritionSettings.dietType.optionBudget.description',
    macro: {
      protein: '18',
      fat: '30',
      carbs: '52',
    },
  },
  {
    id: 4,
    value: DietIdEnum.DIET_ID_CLASSIC,
    optionTitle: 'app.nutritionSettings.dietType.optionClassic.title',
    optionDescription: 'app.nutritionSettings.dietType.optionClassic.description',
    macro: {
      protein: '25',
      fat: '30',
      carbs: '45',
    },
  },
];

export const DIET_MODES = [
  {
    value: DietModeType.slimming,
    optionTitle: 'app.goalSettings.goal.optionWeightLoss.title',
    optionDescription: 'app.goalSettings.goal.optionWeightLoss.description',
  },
  {
    value: DietModeType.stabilization,
    optionTitle: 'app.goalSettings.goal.optionWeightMaintain.title',
    optionDescription: 'app.goalSettings.goal.optionWeightMaintain.description',
  },
  {
    value: DietModeType.gain_muscle_mass,
    optionTitle: 'app.goalSettings.goal.optionBuildMuscle.title',
    optionDescription: 'app.goalSettings.goal.optionBuildMuscle.description',
  },
];

// for i18n-unused
// t('app.goalSettings.dietType.optionBudget.title')
// t('app.goalSettings.dietType.optionBudget.description')
// t('app.goalSettings.dietType.optionHighProtein.title')
// t('app.goalSettings.dietType.optionHighProtein.description')

// t('app.goalSettings.goal.optionWeightLoss.title')
// t('app.goalSettings.goal.optionWeightLoss.description')
// t('app.goalSettings.goal.optionWeightMaintain.title')
// t('app.goalSettings.goal.optionWeightMaintain.description')
// t('app.goalSettings.goal.optionBuildMuscle.title')
// t('app.goalSettings.goal.optionBuildMuscle.description')
